import { Controller as e } from "@hotwired/stimulus";
import { useTransition as t } from "stimulus-use";
class i extends e {
  initialize() {
    this.hide = this.hide.bind(this);
  }
  connect() {
    t(this), this.hiddenValue === !1 && this.show();
  }
  show() {
    this.enter(), this.timeout = setTimeout(this.hide, this.delayValue);
  }
  async hide() {
    this.timeout && clearTimeout(this.timeout), await this.leave(), this.element.remove();
  }
}
i.values = {
  delay: {
    type: Number,
    default: 3e3
  },
  hidden: {
    type: Boolean,
    default: !1
  }
};
export {
  i as default
};
